/**
 * Brazil's platform commission and dispatch wave policy, v1 (W8-GOVERNED-DISPATCH-MONEY, D444, ADR-0076; findings C-01,
 * C-02, D-43, D-44; owner decisions D435 §5 #13, #14 and #15 — the recommended defaults accepted). Country-pack DATA,
 * built here with the keys' own builders (`@vello/config` `platformCommissionSetting`, `@vello/dispatch-strategies`
 * `dispatchWavePolicySetting`) and published by `@vello/pack-seed` through the governed seed path (maker ≠ approver).
 *
 * - `payment.platformCommission` v1 (country BR): 20 % of the fare in every category (#13: "20 % initial") — the value of
 *   the pre-D444 deploy constant, so nothing a driver owes changes on the day it lands; a market or category rate is a
 *   later four-eyes change in the Admin.
 * - `dispatch.wavePolicy` v1 (country BR): TODAY's search and ranking published as they run (#14: "publish the current
 *   values as v1"), plus the auto-pause after 3 ignored offers in a row (#14) and one automatic re-dispatch after a
 *   driver's cancel (#15).
 */
import { platformCommissionSetting } from '@vello/config';
import { PRE_D444_RANKING, PRE_D444_WAVE_SEARCH, dispatchWavePolicySetting } from '@vello/dispatch-strategies';
/** The owner's initial rate (D435 §5 #13), every category. */
export const BRAZIL_PLATFORM_COMMISSION_V1 = { basisPoints: 2000, byCategory: {} };
/** Today's search and ranking + the owner's auto-pause (3) and re-dispatch (1) (D435 §5 #14-15). */
export const BRAZIL_DISPATCH_WAVE_POLICY_V1 = {
    wave: PRE_D444_WAVE_SEARCH,
    ranking: PRE_D444_RANKING,
    autoPause: { ignoredOffersInARow: 3 },
    driverCancel: { redispatchLimit: 1 },
};
/** When both v1 take effect (the D444 build date, UTC). */
export const BRAZIL_DISPATCH_MONEY_EFFECTIVE_FROM = '2026-09-28T00:00:00Z';
/** Brazil's `payment.platformCommission` and `dispatch.wavePolicy` v1 (country scope). */
export function brazilDispatchMoneySettings() {
    return [
        platformCommissionSetting({ scope: 'country', scopeRef: 'BR', value: { basisPoints: BRAZIL_PLATFORM_COMMISSION_V1.basisPoints, byCategory: {} }, version: 1, effectiveFrom: BRAZIL_DISPATCH_MONEY_EFFECTIVE_FROM }),
        dispatchWavePolicySetting({ scope: 'country', scopeRef: 'BR', value: BRAZIL_DISPATCH_WAVE_POLICY_V1, version: 1, effectiveFrom: BRAZIL_DISPATCH_MONEY_EFFECTIVE_FROM }),
    ];
}
//# sourceMappingURL=dispatch-money.js.map